import Icon                 from 'components/Icon/Icon.react';
import React                from 'react';
import history              from 'dashboard/history'
import styles               from 'components/Sidebar/Sidebar.scss';
import LoaderDots           from 'components/LoaderDots/LoaderDots.react';

export default class SidebarSubItem extends React.Component {
  constructor(props) {
    super();
  }

  handleClick(link, e) {
    history.push(link);
    e.preventDefault();
    e.stopPropagation();
  }

  render() {
    let iconContent = null;
    let hasChild = null;
    let classes = [styles.subitem];

    if (this.props.children) {
      classes.push(styles.current);
      hasChild = styles.name
    }

    if (this.props.icon) {
      iconContent = <Icon width={14} height={14} name={this.props.icon} fill='#c5cfdd' colored={true} />;
    }

    if (this.props.active) {
      return (
        <div className={classes.join(' ')}>
          {
            this.props.newFeature
              ? <span className={styles.newFeature}>NEW</span>
              : null
          }
          {
            this.props.betaFeature
              ? <span className={styles.newFeature}>BETA</span>
              : null
          }
          <div className={hasChild}>
            {
              this.props.children
                ? <span className={styles.loaderDots}><LoaderDots /></span>
                : null
            }

            {iconContent}

            <a href={this.props.link} className={this.props.children && this.props.icon ? styles.title : null} onClick={this.handleClick.bind(this, this.props.link)}>
              {this.props.name}
            </a>

            {this.props.action ? this.props.action.renderButton() : null}
          </div>
          {
            this.props.children
              ?
                <div className={[styles.children].join(' ')}>
                  {this.props.children}
                </div>
              : null
          }
        </div>
      );
    }

    return (
      <div className={styles.subitem}>
        {
          this.props.newFeature
            ? <span className={styles.newFeature}>NEW</span>
            : null
        }
        {
          this.props.betaFeature
            ? <span className={styles.newFeature}>BETA</span>
            : null
        }
        <a href={this.props.link} onClick={this.handleClick.bind(this, this.props.link)}>
          {this.props.name}
        </a>
      </div>
    );
  }
}


